import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import TaskInfo from "../TaskInfo";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubProccessApp,
  getSubProccessBprmForm,
  loadSubPrcBprmForm,
  loadSubProccessApp,
  subProcessAppReceived,
} from "../../store/application";
import {
  candidateSubProccessAppsReceived,
  getCandidateSubProccessApps,
  loadCandidateSubProccessApps,
} from "../../store/candidate";
import { getCurrentUser } from "../../store/auth";
import JourneySteps from "../JourneySteps";
import WorkflowElement from "../WorkflowElement";
import BcChecks from "./BcChecks";
import AddBcChecks from "../../../components/OMCRegistry/AddBcChecks";
import Tools from "../../../services/toolsJson.json";
import ToolsPopup from "../../../components/OMCRegistry/ToolsPopup";
import WorkflowMapPopup from "../../../components/WorkflowMapPopup";
import InternalReview from "../../../components/PortalForms/InternalReview";
import { getWfPhasesColor } from "../../../services/appService";

const ProccessApp = (props) => {
  const {
    processShowHide,
    handleProcessShowHide,
    subProccessTask,
    candidateObj,
  } = props;

  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [currentTask, setCurrentTask] = useState(null);
  const [apiCallCount, setApiCallCount] = useState(0);
  const [subProccessId, setSubProccessId] = useState(0);
  const [uploadType, setUploadType] = useState(0);
  const [toolObj, setToolObj] = useState(null);
  const [toolShowHide, setToolShowHide] = useState(false);
  const [journeyShowHide, setJourneyShowHide] = useState(true);
  const [wfForm, setWfForm] = useState(null);
  const [selectedKey, setSelectedKey] = useState("generate");
  const [bcObject, setBcObject] = useState(null);
  const [bcType, setBcType] = useState(null);
  const [sectionShowHide, setSectionShowHide] = useState(false);
  const [workflowShowHide, setWorkflowShowHide] = useState(false);

  const subProccessAppSelector = useSelector(getSubProccessApp);
  const candidateSubProccessAppsSelector = useSelector(
    getCandidateSubProccessApps
  );
  const subPrcBprmFormSelector = useSelector(getSubProccessBprmForm);

  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    if (subProccessTask) {
      dispatch(loadSubProccessApp(subProccessTask));
    }
  }, [subProccessTask]);

  useEffect(() => {
    if (subProccessAppSelector > 0 && subProccessTask?.applicantId) {
      setSubProccessId(subProccessAppSelector);
      setApiCallCount(1);
      dispatch(
        loadCandidateSubProccessApps(
          subProccessTask.applicantId,
          "admin",
          currentUser.id,
          subProccessAppSelector
        )
      );
      dispatch(subProcessAppReceived(0));
    }
  }, [subProccessAppSelector]);

  useEffect(() => {
    if (candidateSubProccessAppsSelector.length > 0) {
      const latestApp = candidateSubProccessAppsSelector[0];
      setSelectedApp(latestApp);
      let wfTasks = latestApp.workflowTasks
        .filter(
          (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 2 //&& x.formType === "WF"
        )
        .sort((a, b) => a.orderNumber - b.orderNumber);

      if (wfTasks.length === 0) {
        wfTasks = latestApp.workflowTasks
          .filter(
            (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 4 //&& x.formType === "WF"
          )
          .sort((a, b) => b.orderNumber - a.orderNumber);
      }
      const latestTask = wfTasks[0];
      if (latestTask?.formId > 0)
        dispatch(loadSubPrcBprmForm(latestTask.formId));
      if (
        (currentTask?.id !== latestTask?.id || apiCallCount > 2) &&
        latestTask?.wiid > 0
      ) {
        setSelectedTask(latestTask.wiid);
        setCurrentTask(latestTask);
      } else {
        if (apiCallCount > 0 && apiCallCount <= 2) {
          setApiCallCount(apiCallCount + 1);
          dispatch(
            loadCandidateSubProccessApps(
              subProccessTask.applicantId,
              "admin",
              1,
              subProccessId
            )
          );
        }
      }
    }
  }, [candidateSubProccessAppsSelector]);

  useEffect(() => {
    if (subPrcBprmFormSelector) setWfForm(subPrcBprmFormSelector);
  }, [subPrcBprmFormSelector]);

  const handleReAssignSubmit = () => { };

  const handleShowHideSection = (status) => {
    setSectionShowHide(status);
  };

  const handleJourneyShowHide = () => {
    setJourneyShowHide(!journeyShowHide);
  };

  const handleJorneySteps = (wiid) => {
    const wfTask = selectedApp.workflowTasks.filter((x) => x.wiid === wiid);
    if (wfTask.length > 0) {
      dispatch(loadSubPrcBprmForm(wfTask[0].formId));
      setSelectedTask(wfTask[0].wiid);
      setCurrentTask(wfTask[0]);
    }
  };

  const handleNextTask = () => {
    setTimeout(() => {
      if (subProccessTask) dispatch(loadSubProccessApp(subProccessTask));
    }, 3000);
  };

  const handleToolShowHide = (r, type) => {
    setUploadType(type);
    setToolShowHide(true);
    const comp = Tools.filter((x) => x.id === r);
    if (comp.length > 0) setToolObj(comp[0]);
  };

  const handleToolObjShowHide = (r, p) => {
    const comp = Tools.filter((x) => x.id === r);
    if (comp.length > 0) {
      const allTasks = selectedApp.workflowTasks.filter((x) => x.wfPhase === p);
      if (allTasks.length > 0) {
        setWfForm(null);
        setSelectedTask(0);
      }

      setToolObj(comp[0]);
    }
  };

  const handleCloseButton = () => {
    dispatch(subProcessAppReceived(0));
    dispatch(candidateSubProccessAppsReceived([]));
    handleProcessShowHide("");
  };

  const handleSelectedKey = (key) => {
    setSelectedKey(key);
    if (key === "addBcCheck") {
      setBcType("new");
      setBcObject(null);
    }
  };

  const handleOpenAddBcCheck = (obj, type) => {
    setBcObject(obj);
    setBcType(type);
    setSelectedKey("addBcCheck");
  };

  const handleSubProcessAppLoad = () => {
    if (subProccessTask) {
      dispatch(loadSubProccessApp(subProccessTask));
    }
  }

  const handleWorkflowModalShowHide = () => {
    setWorkflowShowHide(!workflowShowHide);
  };

  const phaseClass = currentTask?.wfPhase === "Application"
    ? "btn-wf2-default"
    : (getWfPhasesColor(currentTask?.wfPhase) || "btn-default");
  const themeClass = phaseClass.replace("btn-", "theme-");
  const subprocessTaskCount = selectedApp?.workflowTasks?.filter((x) => x.itemType === 1)?.length || 0;
  const subprocessDoneCount = selectedApp?.workflowTasks?.filter((x) => x.itemType === 1 && x.taskDoneStatus === 4)?.length || 0;

  return (
    <>
      <Modal
        show={processShowHide}
        size="xl"
        centered
        onHide={handleCloseButton}
        dialogClassName={`rt-tools-modal sp-modal ${themeClass}`}
      >
        <style>{`
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }
          .modal.fade .sp-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .sp-modal.modal-dialog {
            transform: scale(1) !important;
          }
          .sp-modal {
            --sp-accent: #64748b;
            --sp-soft: #f8fafc;
            width: min(1280px, 94vw) !important;
            max-width: 94vw !important;
            margin: 24px auto !important;
          }
          .sp-modal.theme-primary { --sp-accent: #3b82f6; --sp-soft: #eff6ff; }
          .sp-modal.theme-info { --sp-accent: #06b6d4; --sp-soft: #ecfeff; }
          .sp-modal.theme-warning { --sp-accent: #f59e0b; --sp-soft: #fffbeb; }
          .sp-modal.theme-success { --sp-accent: #22c55e; --sp-soft: #f0fdf4; }
          .sp-modal.theme-wf2-default { --sp-accent: #eab308; --sp-soft: #fef9c3; }
          .sp-modal.theme-wf3-default { --sp-accent: #10b981; --sp-soft: #ecfdf5; }
          .sp-modal.theme-wf4-default { --sp-accent: #ef4444; --sp-soft: #fef2f2; }
          .sp-modal.theme-wf5-default { --sp-accent: #f97316; --sp-soft: #fff7ed; }
          .sp-modal.theme-wf6-default { --sp-accent: #8b5cf6; --sp-soft: #f5f3ff; }
          .sp-modal.theme-default,
          .sp-modal.theme-wf-default { --sp-accent: #64748b; --sp-soft: #f8fafc; }

          .sp-modal .modal-content {
            max-height: calc(100vh - 48px);
            overflow: hidden;
            border: 0;
            border-radius: 12px;
            background: #ffffff;
            box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
          }
          .sp-modal .modal-header {
            position: relative;
            display: block;
            padding: 22px 26px 20px 30px;
            background: linear-gradient(90deg, var(--sp-soft), #ffffff 62%);
            border-bottom: 1px solid #e2e8f0;
          }
          .sp-modal .modal-header::before {
            content: "";
            position: absolute;
            inset: 0 auto 0 0;
            width: 4px;
            background: var(--sp-accent);
          }
          .sp-modal-header-shell {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 18px;
          }
          .sp-modal-title-row {
            display: flex;
            align-items: center;
            gap: 14px;
            min-width: 0;
          }
          .sp-modal-icon {
            width: 52px;
            height: 52px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: var(--sp-accent);
            background: #ffffff;
            border: 1px solid var(--sp-accent);
            box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
            flex-shrink: 0;
          }
          .sp-modal-copy {
            min-width: 0;
          }
          .sp-modal-kicker {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 5px;
            color: #64748b;
            font-size: 11px;
            font-weight: 850;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .sp-modal-title {
            margin: 0;
            color: #0f172a;
            font-size: 20px;
            font-weight: 850;
            line-height: 1.2;
          }
          .sp-modal-meta {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 8px;
            margin-top: 10px;
          }
          .sp-modal-chip {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 5px 9px;
            border-radius: 8px;
            color: #475569;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            font-size: 11px;
            font-weight: 750;
          }
          .sp-modal-chip i {
            color: var(--sp-accent);
          }
          .sp-close-btn {
            width: 38px;
            height: 38px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #cbd5e1;
            border-radius: 8px;
            background: #ffffff;
            color: #64748b;
            transition: all 0.2s ease;
          }
          .sp-close-btn:hover {
            color: #0f172a;
            background: #f8fafc;
            border-color: #94a3b8;
          }
          .sp-modal .modal-body {
            flex: 1 1 auto;
            padding: 18px;
            background: #f8fafc;
            max-height: calc(100vh - 190px);
            overflow-y: auto;
          }
          .sp-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
          }
          .sp-modal .wf-modal-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .sp-modal .wf-modal-footer-close-btn:hover {
            background: #ffffff !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .sp-modal .wf-modal-footer-close-btn:active {
            transform: translateY(0) !important;
          }
          .sp-modal .wf-modal-footer-close-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
          }
          .sp-modal .wf-modal-footer-close-btn:hover i {
            color: #ef4444 !important;
          }
          .sp-task-summary-wrap {
            margin-bottom: 14px;
          }
          .sp-modal .wf-tab-bar {
            display: flex;
            align-items: stretch;
            flex-wrap: wrap;
            gap: 4px;
            border-bottom: 2px solid #f1f5f9;
            margin-bottom: 12px;
            padding: 8px 4px 0;
            position: relative;
          }
          .sp-modal .wf-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 7px;
            border: none;
            background: transparent;
            color: #475569;
            font-size: 13.5px;
            font-weight: 650;
            padding: 9px 16px 11px;
            border-radius: 8px 8px 0 0;
            cursor: pointer;
            outline: none;
            white-space: nowrap;
            transition: color 0.2s ease, background 0.2s ease;
          }
          .sp-modal .wf-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .sp-modal .wf-tab-btn:hover {
            color: #1e293b;
            background: rgba(37, 99, 235, 0.04);
          }
          .sp-modal .wf-tab-btn:focus,
          .sp-modal .wf-tab-btn:focus-visible,
          .sp-modal .wf-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .sp-modal .wf-tab-btn.active {
            color: #2563eb;
            font-weight: 700;
          }
          .sp-modal .wf-tab-btn.active i {
            color: #2563eb;
          }
          .sp-modal .wf-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: #2563eb;
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .sp-modal .wf-tab-btn.active::after {
            transform: scaleX(1);
          }
          .sp-modal .wf-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 999px;
            font-size: 10px;
            font-weight: 700;
            line-height: 1;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            transition: all 0.2s ease;
          }
          .sp-modal .wf-tab-btn.active .wf-tab-badge {
            background: rgba(37, 99, 235, 0.1);
            color: #1d4ed8;
            border-color: rgba(37, 99, 235, 0.2);
          }
          .sp-tab-panel {
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            background: #ffffff;
            overflow: hidden;
          }
          .sp-workbench-shell {
            position: relative;
            width: 100%;
            overflow: hidden;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
          }
          .sp-workbench-body {
            display: flex;
            min-height: 520px;
          }
          .sp-journey-pane {
            width: 330px;
            min-width: 330px;
            display: flex;
            flex-direction: column;
            border-right: 1px solid #e2e8f0;
            background: #fbfdff;
          }
          .sp-workbench-shell.collapsed .sp-journey-pane {
            width: 72px;
            min-width: 72px;
          }
          .sp-main-pane {
            min-width: 0;
            flex: 1;
            display: flex;
            flex-direction: column;
            background: #ffffff;
          }
          .sp-task-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            min-height: 56px;
            padding: 13px 15px;
            color: #1e293b;
            font-size: 13px;
            font-weight: 850;
            background: #ffffff;
            border-bottom: 2px solid #f1f5f9;
            border-left: 4px solid transparent;
          }
          .sp-task-header.phase {
            border-left-color: var(--sp-accent);
          }
          .sp-task-header.workflow-phases {
            border-left-color: transparent;
          }
          .sp-workbench-shell.collapsed .sp-task-header.workflow-phases {
            justify-content: center;
            padding-left: 0;
            padding-right: 0;
          }
          .sp-task-title {
            display: inline-flex;
            align-items: center;
            gap: 9px;
            min-width: 0;
            color: #0f172a;
            text-transform: uppercase;
            letter-spacing: 0.02em;
            font-weight: 850;
          }
          .sp-task-title-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            min-width: 32px;
            height: 32px;
            border-radius: 10px;
            color: var(--sp-accent);
            background: var(--sp-soft);
            border: 1px solid rgba(148, 163, 184, 0.35);
          }
          .sp-task-info {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            min-width: 0;
            overflow: hidden;
          }
          .sp-task-phase-name {
            color: #64748b;
            font-weight: 750;
          }
          .sp-task-separator {
            color: #cbd5e1;
            font-weight: 500;
          }
          .sp-task-item-name {
            color: #0f172a;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .sp-action-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 7px 10px;
            min-width: 38px;
            min-height: 38px;
            border-radius: 8px;
            border: 1px solid #cbd5e1;
            background: #ffffff;
            color: #475569;
            font-size: 11px;
            font-weight: 800;
            transition: all 0.2s ease;
          }
          .sp-action-btn:hover {
            color: #0f172a;
            border-color: var(--sp-accent);
            background: var(--sp-soft);
          }
          .sp-journey-content {
            flex: 1;
            overflow-y: auto;
          }
          .sp-content-pane {
            min-width: 0;
            flex: 1;
            background: #ffffff;
          }
          .sp-content-scroll {
            width: 100%;
            max-width: 100%;
            overflow-x: auto;
            overflow-y: visible;
            padding: 14px;
          }
          .sp-content-scroll > .row {
            min-width: 720px;
          }
          .sp-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 360px;
            gap: 12px;
            text-align: center;
            animation: spFadeIn 0.3s ease both;
          }
          @keyframes spFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          .sp-empty-icon {
            width: 56px;
            height: 56px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            background: var(--sp-soft);
            border: 1px solid rgba(0, 0, 0, 0.06);
            color: var(--sp-accent);
            margin-bottom: 4px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
            transition: all 0.3s ease;
          }
          .sp-empty-state:hover .sp-empty-icon {
            transform: translateY(-2px) scale(1.02);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.04);
            border-color: var(--sp-accent);
          }
          .sp-empty-title {
            margin: 0;
            color: #0f172a;
            font-size: 15px;
            font-weight: 750;
            letter-spacing: -0.01em;
          }
          .sp-empty-desc {
            margin: 0 auto;
            color: #64748b;
            font-size: 13px;
            max-width: 320px;
            line-height: 1.6;
          }
          @media (max-width: 900px) {
            .sp-workbench-body {
              flex-direction: column;
            }
            .sp-journey-pane,
            .sp-workbench-shell.collapsed .sp-journey-pane {
              width: 100%;
              min-width: 100%;
              border-right: 0;
              border-bottom: 1px solid #e2e8f0;
            }
          }
        `}</style>
        <Modal.Header>
          <div className="sp-modal-header-shell">
            <div className="sp-modal-title-row">
              <span className="sp-modal-icon">
                <i className="fa fa-sitemap" aria-hidden="true" />
              </span>
              <div className="sp-modal-copy">
                <div className="sp-modal-kicker">
                  <span>Main workflow subprocess</span>
                </div>
                <h2 className="sp-modal-title">{subProccessTask?.itemName || "Subprocess"}</h2>
                <div className="sp-modal-meta">
                  {currentTask?.wfPhase && (
                    <span className="sp-modal-chip">
                      <i className="fa fa-code-fork" aria-hidden="true" />
                      {currentTask.wfPhase}
                    </span>
                  )}
                  <span className="sp-modal-chip">
                    <i className="fa fa-list-ul" aria-hidden="true" />
                    {subprocessDoneCount}/{subprocessTaskCount} tasks done
                  </span>
                  {selectedApp?.workflowId && (
                    <span className="sp-modal-chip">
                      <i className="fa fa-map-o" aria-hidden="true" />
                      Workflow #{selectedApp.workflowId}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <button type="button" className="sp-close-btn" onClick={handleCloseButton} title="Close subprocess">
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 sp-task-summary-wrap">
              {currentTask && (
                <TaskInfo
                  wfTask={currentTask}
                  app={selectedApp}
                  handleReAssignSubmit={handleReAssignSubmit}
                  handleShowHideSection={handleShowHideSection}
                  handleWorkflowModalShowHide={handleWorkflowModalShowHide}
                />
              )}
            </div>
            <div className="col-md-12">
                <div className="wf-tab-bar" role="tablist" aria-label="Subprocess sections">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={selectedKey === "generate"}
                    className={`wf-tab-btn${selectedKey === "generate" ? " active" : ""}`}
                    onClick={() => handleSelectedKey("generate")}
                  >
                    <i className="fa fa-road" aria-hidden="true" />
                    Journey & Task
                    <span className="wf-tab-badge">{subprocessTaskCount || "—"}</span>
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={selectedKey === "poOrder"}
                    className={`wf-tab-btn${selectedKey === "poOrder" ? " active" : ""}`}
                    onClick={() => handleSelectedKey("poOrder")}
                  >
                    <i className="fa fa-shield" aria-hidden="true" />
                    Background Checks
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={selectedKey === "addBcCheck"}
                    className={`wf-tab-btn${selectedKey === "addBcCheck" ? " active" : ""}`}
                    onClick={() => handleSelectedKey("addBcCheck")}
                  >
                    <i className={selectedKey === "addBcCheck" && bcType === "edit" ? "fa fa-pencil-square-o" : selectedKey === "addBcCheck" && bcType === "notify" ? "fa fa-paper-plane-o" : "fa fa-plus-circle"} aria-hidden="true" />
                    {selectedKey === "addBcCheck" && bcType === "edit" ? "Edit Check" : selectedKey === "addBcCheck" && bcType === "notify" ? "Notify Candidate" : "Add Check"}
                  </button>
              </div>

              {selectedKey === "generate" && (
                <div className="sp-tab-panel" role="tabpanel">
                  <div className={`sp-workbench-shell ${journeyShowHide ? "" : "collapsed"}`}>
                    {selectedApp ? (
                      <div className="sp-workbench-body">
                        <aside className="sp-journey-pane">
                          <div className="sp-task-header workflow-phases">
                            {journeyShowHide && (
                              <div className="sp-task-title">
                                <span className="sp-task-title-icon">
                                  <i className="fa fa-road" aria-hidden="true" />
                                </span>
                                <span>Workflow Phases</span>
                              </div>
                            )}
                            <button
                              className="sp-action-btn"
                              type="button"
                              onClick={handleJourneyShowHide}
                              aria-label={journeyShowHide ? "Hide subprocess phases" : "Show subprocess phases"}
                              title={journeyShowHide ? "Hide subprocess phases" : "Show subprocess phases"}
                            >
                              <i className={`fa ${journeyShowHide ? "fa-angle-double-left" : "fa-angle-double-right"}`} aria-hidden="true" />
                            </button>
                          </div>
                          <div className="sp-journey-content">
                            <JourneySteps
                              custApp={selectedApp}
                              handleJorneySteps={handleJorneySteps}
                              handleToolShowHide={handleToolShowHide}
                              handleToolObjShowHide={handleToolObjShowHide}
                              selectedTaskId={selectedTask}
                              journeyShowHide={journeyShowHide}
                            />
                          </div>
                        </aside>
                        <main className="sp-main-pane">
                          <div className="sp-task-header phase">
                            <div className="sp-task-title">
                              <span className="sp-task-title-icon">
                                <i className="fa fa-tasks" aria-hidden="true" />
                              </span>
                              <div className="sp-task-info">
                                <span className="sp-task-phase-name">{currentTask?.wfPhase === "Application" ? "Review" : currentTask?.wfPhase || "Task"}</span>
                                {currentTask?.itemName && (
                                  <>
                                    <span className="sp-task-separator">/</span>
                                    <span className="sp-task-item-name">{currentTask.itemName}</span>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="sp-workbench-actions">
                              <button className="sp-action-btn" type="button" onClick={handleSubProcessAppLoad} title="Refresh subprocess">
                                <i className="fa fa-refresh" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                          <div className="sp-content-scroll">
                            {selectedTask === 0 && toolObj?.id === 1 && (
                              <InternalReview workflowTask={currentTask} />
                            )}
                            {wfForm ? (
                              <WorkflowElement
                                wfTask={currentTask}
                                wfForm={wfForm}
                                handleNextTask={handleNextTask}
                                handleCloseButton={handleCloseButton}
                                viewType={
                                  currentUser?.type === "admin"
                                    ? false
                                    : String(currentTask?.performerId) === String(currentUser?.id)
                                      ? false
                                      : true
                                }
                              />
                            ) : (
                              <div className="sp-empty-state">
                                <div className="sp-empty-icon">
                                  <i className="fa fa-file-o" aria-hidden="true" />
                                </div>
                                <h5 className="sp-empty-title">No subprocess task selected</h5>
                                <p className="sp-empty-desc">Select an available task from the subprocess journey.</p>
                              </div>
                            )}
                          </div>
                        </main>
                      </div>
                    ) : (
                      <div className="sp-empty-state">
                        <div className="sp-empty-icon">
                          <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                        </div>
                        <h5 className="sp-empty-title">Loading subprocess</h5>
                        <p className="sp-empty-desc">Preparing the subprocess journey and task content.</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {selectedKey === "poOrder" && (
                <div className="sp-tab-panel p-3" role="tabpanel">
                  <div className="row">
                    <BcChecks
                      subProccessTask={currentTask}
                      candidateObj={candidateObj}
                      onOpenAddBcCheck={handleOpenAddBcCheck}
                    />
                  </div>
                </div>
              )}

              {selectedKey === "addBcCheck" && (
                <div className="sp-tab-panel" role="tabpanel">
                  <div className="row" style={{ margin: 0 }}>
                    <AddBcChecks
                      bcCheckShowHide={true}
                      handleBcCheckShowHide={(obj, type) => {
                        setSelectedKey("poOrder");
                        setBcType(null);
                        setBcObject(null);
                      }}
                      candidateObj={candidateObj}
                      workItem={currentTask}
                      bcType={bcType}
                      bcObject={bcObject}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleCloseButton}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {toolShowHide && (
        <ToolsPopup
          toolShowHide={toolShowHide}
          handleToolShowHide={handleToolShowHide}
          toolObj={toolObj}
          item={selectedApp}
          task={currentTask}
          app={selectedApp}
          candidateObj={candidateObj}
          uploadType={uploadType}
        //setViewBprmFormShowHide={setViewBprmFormShowHide}
        ></ToolsPopup>
      )}
      {workflowShowHide && (
        <WorkflowMapPopup
          workflowShowHide={workflowShowHide}
          handleWorkflowModalShowHide={handleWorkflowModalShowHide}
          selectedObj={currentTask}
        />
      )}
    </>
  );
};

export default ProccessApp;
